module.exports = __webpack_public_path__ + "img/people_img_5_2.b8582a03.png";